import Swal, { SweetAlertIcon } from 'sweetalert2';

interface ConfirmActionOptions {
    title?: string;
    text: string;
    icon?: SweetAlertIcon;
    confirmButtonText?: string;
    confirmButtonColor?: string;
    cancelButtonColor?: string;
}

export const showValidationAlert = (text: string) =>
    Swal.fire({
        title: 'Validation Error',
        text,
        icon: 'warning'
    });

export const showErrorAlert = (text: string, title = 'Error') =>
    Swal.fire({
        title,
        text,
        icon: 'error'
    });

export const showSuccessToast = (title: string) =>
    Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title,
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true
    });

export const showInfoToast = (title: string, icon: SweetAlertIcon = 'success') =>
    Swal.fire({
        toast: true,
        position: 'top-end',
        icon,
        title,
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true
    });

export const confirmAction = async ({
    title = 'Are you sure?',
    text,
    icon = 'warning',
    confirmButtonText = 'Yes, continue',
    confirmButtonColor = '#dc2626',
    cancelButtonColor = '#6b7280'
}: ConfirmActionOptions) => {
    const result = await Swal.fire({
        title,
        text,
        icon,
        showCancelButton: true,
        confirmButtonText,
        confirmButtonColor,
        cancelButtonColor
    });

    return result.isConfirmed;
};
